export default "__VITE_ASSET__CbU9dgZZ__"